"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _FormInput = _interopRequireDefault(require("../../Components/Form/FormInput"));

var _Validator = _interopRequireDefault(require("../../Validators/Validator"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _componentAnalytics = require("../../Components/ComponentAnalytics/componentAnalytics");

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FormEmail = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var onChange = _ref.onChange,
      label = _ref.label,
      initialValue = _ref.initialValue,
      helpMessage = _ref.helpMessage,
      errorMessage = _ref.errorMessage,
      requiredMessage = _ref.requiredMessage,
      required = _ref.required,
      disabled = _ref.disabled,
      validateOnFly = _ref.validateOnFly,
      onValidateOnFlyChange = _ref.onValidateOnFlyChange,
      inputWidth = _ref.inputWidth;
  (0, _react.useEffect)(function () {
    (0, _componentAnalytics.trackMe)("FormEmail");
  }, []);

  var validateEmail = function validateEmail(value) {
    if (required && "" === value) {
      return requiredMessage;
    }

    return _Validator.default.email(value) ? "" : errorMessage || "Invalid email address. Please use the format example@email.com.";
  };

  var isInitialMount = (0, _react.useRef)(!0);

  var _useState = (0, _react.useState)(initialValue),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = (0, _react.useState)(validateOnFly ? validateEmail(initialValue) : ""),
      errorText = _useState2[0],
      setErrorText = _useState2[1];

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      validate: function validate() {
        var error = validateEmail(email);
        setErrorText(error);
        return !error;
      }
    };
  });
  (0, _react.useEffect)(function () {
    if (!email) {
      setEmail(initialValue);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [initialValue]);
  (0, _react.useEffect)(function () {
    if (isInitialMount.current) {
      isInitialMount.current = !1;
    } else {
      var event = {
        email: email
      };

      if (validateOnFly) {
        event.emailErrorMessage = errorText;
      }

      onChange(event);
    }
  }, [email, errorText, onChange, validateOnFly]);
  (0, _react.useEffect)(function () {
    onValidateOnFlyChange && onValidateOnFlyChange(validateOnFly);
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [validateOnFly]);
  return /*#__PURE__*/_react.default.createElement(_FormInput.default, {
    type: "email",
    className: "email-input",
    "data-test": "email",
    "data-testid": "email",
    maxLength: 80,
    label: label,
    value: email,
    hasError: !!errorText,
    errorMessage: errorText,
    disabled: disabled,
    onChange: function handleEmailChange(event) {
      var currentEmail = event.target.value;
      setEmail(currentEmail);
      setErrorText("");
    },
    onBlur: function handleEmailBlur() {
      validateOnFly && setErrorText(validateEmail(email));
    },
    helpMessage: helpMessage,
    inputWidth: inputWidth
  });
});
FormEmail.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  onValidateOnFlyChange: _propTypes.default.func,
  label: _propTypes.default.string,
  helpMessage: _propTypes.default.string,
  initialValue: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  requiredMessage: _propTypes.default.string,
  required: _propTypes.default.bool,
  validateOnFly: _propTypes.default.bool
};
FormEmail.defaultProps = {
  label: "Email",
  helpMessage: "",
  initialValue: "",
  errorMessage: "",
  disabled: !1,
  requiredMessage: "Email address is required.",
  required: !1,
  validateOnFly: !0
};
var _default = FormEmail;
exports.default = _default;